import React from 'react'
import Logo from '../Assets/Images/proton.png'
import '../Assets/Styles/Footer.css'
const Footer = () => {
  return (
    <div>
         <footer className="footer">
      <div className="logo-email">
        <div className="footer-logo">
          <img src={Logo} alt="" className='footer-logo'/>
        </div>
        <div className="email mt-3">proton@protoneffect.com</div>
      </div>
      <div className="social-icons">
        <a href="#" aria-label="Facebook">
          <i className="fab fa-facebook-f"></i>
        </a>
        <a href="#" aria-label="Twitter">
          <i className="fab fa-twitter"></i>
        </a>
        <a href="#" aria-label="LinkedIn">
          <i className="fab fa-linkedin-in"></i>
        </a>
      </div>
    </footer>
    </div>
  )
}

export default Footer